import { Button } from '@mui/material';

import { ConfirmDialog } from 'src/components/custom-dialog/confirm-dialog';

function SettingsConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <ConfirmDialog
      open={isOpen}
      onClose={onClose}
      title="Update Model"
      content={<>Switching to a new model will reset your current conversation.</>}
      action={
        <Button variant="contained" color="error" onClick={onConfirm}>
          Confirm
        </Button>
      }
    />
  );
}

export default SettingsConfirmDialog;
